export const MARKER_COLOR_ACTIVE = 0xff0000
export const MARKER_COLOR_INACTIVE = 0xa9a9a9

export const MARKER_COLOR_ACTIVE_CSS = '#ff0000'
export const MARKER_COLOR_INACTIVE_CSS = '#a9a9a9'
